import { Controller } from "@hotwired/stimulus";
import Tooltip from "bootstrap/js/dist/tooltip";

// Connects to data-controller="shared--tooltip-init"
// Initializes Bootstrap tooltips for all elements with data-bs-toggle="tooltip"
export default class extends Controller {
  connect() {
    this.element
      .querySelectorAll('[data-bs-toggle="tooltip"]')
      .forEach((el) => Tooltip.getOrCreateInstance(el));
  }

  disconnect() {
    this.element
      .querySelectorAll('[data-bs-toggle="tooltip"]')
      .forEach((el) => Tooltip.getInstance(el)?.dispose());
  }
}
